import "./vengeance.scss";
import "../perfume.scss";

// Images
import MainVideoWEBM from "assets/video/perfume/vengeance/vengeance_web.webm";
// import MainVideoMobWEBM from "assets/video/perfume/vengeance/vengeance_mob.webm";
import MainVideoMobWEBM from "assets/video/perfume/vengeance/vengeance_mobBG.webm";
import MainImage from "assets/img/perfume/vengeance_main.webp";
import ConcentrationImage from "assets/img/perfume/vengeance_concentration.webp";
import Ingredients1 from "assets/img/perfume/ingredients/grapefruit.webp";
import Ingredients2 from "assets/img/perfume/ingredients/violet-leaf.webp";
import Ingredients3 from "assets/img/perfume/ingredients/lavender.webp";
import Ingredients4 from "assets/img/perfume/ingredients/cashmeran.webp";
import Ingredients5 from "assets/img/perfume/ingredients/clary-sage.webp";
import Ingredients6 from "assets/img/perfume/ingredients/geranium.webp";
import Ingredients7 from "assets/img/perfume/ingredients/tonka-bean.webp";
import Ingredients8 from "assets/img/perfume/ingredients/vetiver.webp";
import Details from "../components/details/Details";
import productStore from "store/productStore";
import { useEffect, useState } from "react";
import ProductReview from "../components/productReview/ProductReview";
import ProductSlider from "../components/productSlider/ProductSlider";
import Ingredients from "../components/ingredients/Ingredients";
import FirstContent from "../components/firstContent/FirstContent";
import Concentration from "../components/concentration/Concentration";
import SEO from "components/seo/SEO";
import { VENGEANCE_ID } from "constant";
import ProductSliderNew from "../components/productSlider/ProductSliderNew";
import VideoWithEndImageNew from "../components/videoWithEndImage/VideoWithEndImageNew";
import sliderImage1 from "assets/img/perfume/slider/posttrioswipe1ve.webp";
import sliderImage2 from "assets/img/perfume/slider/posttrioswipe2ve.webp";
import imageLoadStore from "store/imageLoadStore";
import MyLoader from "components/myLoader/MyLoader";

const Vengeance = () => {
  const ImageLoadStore = imageLoadStore();
  const ProductStore = productStore();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const AccordionDetails = [
    {
      label: "DESCRIPTION",
      content: (
        <div>
          A bold yet refined fresh-woody perfume crafted for the modern man.
          Vengeance opens with a crisp burst of grapefruit and lavender, giving
          a clean and energetic first impression. As it settles, warm tonka bean
          and clary sage add a smooth spicy character. The base of vetiver,
          cashmeran, musk, and vanilla creates a deep, masculine woody finish
          that lasts for hours.
          <br />
          <br />
          This long-lasting men’s fragrance is perfect for daily wear, office
          settings, and confident evening outings. Balanced, powerful, and
          effortlessly attractive.
        </div>
      ),
    },
    {
      label: "FRAGRANCE NOTES",
      content: (
        <p>
          <strong>Top Notes: </strong>Grapefruit, Violet Leaf, Lavender
          <br />
          <strong>Middle Notes: </strong>Tonka Bean, Geranium, Clary Sage
          <br />
          <strong>Base Notes: </strong>Vetiver, Cashmeran, Musk, Vanilla
        </p>
      ),
    },
    {
      label: "FEELINGS",
      content: <p>Confident • Grounded • Bold • Charismatic • Powerful</p>,
    },
    {
      label: "OCCASIONS",
      content: (
        <ol>
          <li>Office Wear</li>
          <li>Date Nights</li>
          <li>Evening Events</li>
          <li>Daily Signature Scent</li>
        </ol>
      ),
    },
    {
      label: "BEHIND THE PERFUME",
      content: (
        <p>
          Vengeance is designed for men who lead with confidence. The fresh
          citrus opening blends into a spicy-woody core, finishing with creamy
          vanilla and musk for long-lasting impact. A versatile masculine
          fragrance that leaves a strong impression without being overpowering.
        </p>
      ),
    },
    {
      label: "SHIPPING & RETURN",
      content: (
        <p>
          We carefully pack and dispatch all orders to ensure safe delivery.
          Orders are processed within standard business timelines.
          <br />
          <strong>Please note:</strong> Due to hygiene and product safety
          reasons, we do not accept returns or exchanges once the product has
          been delivered.
        </p>
      ),
    },
    {
      label: "LEGAL INFORMATION",
      content: (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div>
            <p style={{ fontWeight: 700 }}>Marketed by KRISTIVE</p>
            <p>
              105, Shubham Residency 1, Navagam Surat 394210, Gujarat, India
            </p>
          </div>
          <div>
            <p>
              <strong>Customer Care:</strong>
            </p>
            <p>
              <strong>Email</strong> - support@kristive.com
            </p>
            <p>
              <strong>Call</strong> - +91 81601 92573
            </p>
            <p>
              <strong>Website</strong> - www.kristive.com
            </p>
          </div>
          <div>
            <p>
              <strong>Manufactured by</strong>
            </p>
            <p>
              MINATI ESSENTIALS 8, Laxmi Narayan Industries, Udhna Surat,
              Gujarat - 394210
            </p>
            <strong>Lic. No.: </strong>GC/2055
          </div>
          <div>
            <p>
              <strong>Country of Origin:</strong> India
            </p>
            <p>
              <strong>Net Contents:</strong> 50ML / 1.7 fl. oz
            </p>
          </div>
          <div>
            <p>
              <strong>Ingredients:</strong>
            </p>
            <p>
              Linalool, Geraniol, Limonene, Eugenol, Denatured Ethyl Alcohol,
              Fragrance Oil.
            </p>
          </div>

          <div>
            <p>For External Use Only.</p>
            <p>Store in a Cool & Dry Place.</p>
          </div>

          <div>
            <p>
              <strong>Usage:</strong>
            </p>
            <p>
              To avoid staining, spray perfume from a safe distance of 15-20 cm.
            </p>
          </div>
          <div>
            <p>
              <strong>Warning:</strong>
            </p>
            <p>Keep away from children and pets.</p>
            <p>Avoid contact with eyes, mouth, and broken skin.</p>
            <p>Flammable - Keep away from heat, sparks, and open flame.</p>
          </div>

          <div>
            <p>
              <strong>Generic Name:</strong> Perfume
            </p>
            <p>Best Before: 36 months from manufacturing date.</p>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0 });
    fetchSpecificProductRating();
    if (ImageLoadStore.imageLoading) {
      setTimeout(() => {
        document.body.style.overflowY = "hidden";
      }, 50);
    }
  }, []);

  const fetchSpecificProductRating = async () => {
    setIsLoading(true);
    const product = await ProductStore.fetchOneProduct({
      _id: VENGEANCE_ID,
    });
    setProduct(product);
    setIsLoading(false);
  };

  return (
    <>
      <SEO
        title="Vengeance Perfume for Men | Fresh Woody Spicy Fragrance | 50ml"
        description="Discover Vengeance, a long-lasting men’s perfume with fresh grapefruit, spicy tonka bean, and woody vetiver. A confident everyday fragrance with a smooth vanilla finish."
      />

      {ImageLoadStore.imageLoading && (
        <div className="loading">
          <MyLoader height="100vh" />
        </div>
      )}
      <div className="perfume-details vengeance">
        <VideoWithEndImageNew
          websiteVideoWEBM={MainVideoWEBM}
          mobileVideoWEBM={MainVideoMobWEBM}
          product={product}
          slogan="Bold. Powerful. Unforgettable."
        />

        <ProductSliderNew images={[sliderImage1, sliderImage2]} />

        <div className="content">
          {/* <FirstContent
            title={"VENGEANCE"}
            shortDescription={"Intensity in Every Drop"}
            image={MainImage}
            id={VENGEANCE_ID}
            productName={product?.productName || ""}
            regularPrice={product?.regularPrice || ""}
            salePrice={product?.salePrice || null}
          /> */}

          {/* {product?.productImages.length > 0 && (
            <ProductSlider images={product?.productImages || []} />
          )} */}
          {/* {product?.productImages.length > 0 && (
            <ProductSliderNew images={product?.productImages || []} />
          )} */}

          <Ingredients
            Ingredients1={{
              img: Ingredients1,
              name: "Grapefruit",
              desc: "Sharp, zesty citrus opening with a crisp masculine edge",
            }}
            Ingredients2={{
              img: Ingredients2,
              name: "Violet Leaf",
              desc: "Green, fresh note adding a cool modern sharpness",
            }}
            Ingredients3={{
              img: Ingredients3,
              name: "Lavender",
              desc: "Clean aromatic freshness with a classic masculine touch",
            }}
            Ingredients4={{
              img: Ingredients4,
              name: "Tonka Bean",
              desc: "Warm, slightly sweet depth with a smooth spicy nuance",
            }}
            Ingredients5={{
              img: Ingredients5,
              name: "Geranium",
              desc: "Fresh floral with a crisp, slightly minty masculinity",
            }}
            Ingredients6={{
              img: Ingredients6,
              name: "Clary Sage",
              desc: "Herbal and earthy with a refined aromatic intensity",
            }}
            Ingredients7={{
              img: Ingredients7,
              name: "Vetiver",
              desc: "Dry, earthy wood with a smoky masculine depth",
            }}
            Ingredients8={{
              img: Ingredients8,
              name: "Cashmeran",
              desc: "Smooth woody musk with a warm, modern sensual feel",
            }}
          />

          <Concentration
            image={ConcentrationImage}
            percentage={25}
            shortDescription={
              "Elegant Blend of Fruity Freshness and Deep Floral Richness"
            }
          />

          <Details items={AccordionDetails} />

          <ProductReview
            isLoading={isLoading}
            averageRating={product?.averageRating || 0}
            totalReview={product?.ratingCount || 0}
            ratings={product?.ratings || []}
            particularRatings={{
              fiveStar: product?.fiveStar,
              fourStar: product?.fourStar,
              threeStar: product?.threeStar,
              twoStar: product?.twoStar,
              oneStar: product?.oneStar,
            }}
            appBarColor="#631e15"
          />
        </div>
      </div>
    </>
  );
};

export default Vengeance;
